module.exports = __webpack_public_path__ + "static/media/Refer and Earn.f1fb43fa.png";